// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"16ab1ba4","310":"44c80328","414":"5a50ae6c","769":"5c2712bc","822":"e64c8249","906":"f6653cc5"}[chunkId] + ".chunk.js";
};